export class Token {
    constructor(key, value) {
        this.key = key;
        this.value = value;
    }
}

export class Options {
    constructor(langParameterName, tokens) {
        this.langParameterName = langParameterName;
        this.tokens = tokens;
    }
}